import {
  DomainOrderStatus,
  DomainLifecycleStatus,
} from '@tiendanube/common/src/domains/nuvem-domains/types';

/**
 * Domain Order Statuses
 */

/** Order statuses for payment/purchase in progress */
export const DOMAIN_ORDER_PROCESSING_STATUSES = [
  DomainOrderStatus.PENDING_PAYMENT,
  DomainOrderStatus.PAID,
  DomainOrderStatus.PURCHASING,
];

/** Order error statuses that allow retry */
export const DOMAIN_ORDER_ERROR_STATUSES = [
  DomainOrderStatus.FAILED,
  DomainOrderStatus.CANCELLED,
];

/** Order statuses for domain errors (already taken or purchase failed) */
export const DOMAIN_ORDER_PURCHASE_ERROR_STATUSES = [
  DomainOrderStatus.DOMAIN_TAKEN,
  DomainOrderStatus.PURCHASE_FAILED,
];

/** Order statuses that should redirect to list from landing page */
export const DOMAIN_ORDER_REDIRECT_TO_LIST_STATUSES = [
  DomainOrderStatus.EXPIRED,
  DomainOrderStatus.CREATED,
  DomainOrderStatus.FAILED,
  DomainOrderStatus.CANCELLED,
];

/** Order statuses that require redirection to order details */
export const DOMAIN_ORDER_REDIRECT_TO_DETAILS_STATUSES = [
  DomainOrderStatus.PURCHASE_FAILED,
  DomainOrderStatus.DOMAIN_TAKEN,
  DomainOrderStatus.PURCHASED,
];

/**
 * Domain Lifecycle Statuses
 */

/** Domain lifecycle statuses for pending verification */
export const DOMAIN_LIFECYCLE_PENDING_VERIFICATION_STATUSES = [
  DomainLifecycleStatus.REGISTERING_DOMAIN,
  DomainLifecycleStatus.PENDING_EMAIL_VERIFICATION,
];
